// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__1Z-JS","icon":"EnquiryForm_icon__28gca","heading":"EnquiryForm_heading__50ZPc","field":"EnquiryForm_field__204PK","error":"EnquiryForm_error__3K-Xy"};